var routes = [
  {
    path: '/baoxiu',
    name: '网络报修',
    component: resolve => { require(['@/baoxiu/index'], resolve) },
    children: [{
      path: '/baoxiu/create/:base_type',
      component: () => import('@/baoxiu/view/create'),
      name: '故障申报'
    },{
      path: '/baoxiu/mylist/:base_type',
      component: () => import('@/baoxiu/view/mylist'),
      name: '我的报修数据'
    },{
      path: '/baoxiu/manager/:base_type',
      component: () => import('@/baoxiu/view/manager'),
      name: '待我分配的报修数据'
    },{
      path: '/baoxiu/worker/:base_type',
      component: () => import('@/baoxiu/view/worker'),
      name: '我的报修工单'
    },{
      path: '/baoxiu/preview/:base_type/:faultid',
      component: () => import('@/baoxiu/view/preview'),
      name: '报修单详情'
    }]
  },
  {
    path: '/faultRepair',
    name: '故障报修',
    component: resolve => { require(['@/faultRepair/index'], resolve) },
    children: [{
      path: '/faultRepair/creae',
      component: () => import('@/faultRepair/view/create'),
      name: '故障报修申请'
    },{
      path: '/faultRepair/user',
      component: () => import('@/faultRepair/view/user'),
      name: '我的报修单'
    },{
      path: '/faultRepair/preview/:faultid',
      component: () => import('@/faultRepair/view/preview'),
      name: '报修详情'
    },{
      path: '/faultRepair/manager',
      component: () => import('@/faultRepair/view/manager'),
      name: '报修单管理'
    }]
  },{
    path: '/wages',
    name: '工资查询',
    component: (resolve) => require(['@/wages/index'], resolve)
  },{
    path: '/wagesDetails',
    name: '工资详情',
    component: (resolve) => require(['@/wages/details'], resolve)
  },{
    path: '/rota',
    name: '值班查询',
    component: (resolve) => require(['@/rota/index'], resolve)
  },{
    path: '/home',
    name: '宁夏职业技术学院',
    component: (resolve) => require(['@/home/index'], resolve),
    children: [{
      path: '/home/grid/:agentid',
      component: () => import('@/home/view/grid'),
      name: '宁夏职业技术学院移动微校园1'
    },{
      path: '/home/list/:agentid',
      component: () => import('@/home/view/list'),
      name: '列表'
    }]
  },{
    path: '/newHome',
    name: '宁夏职业技术学院移动微校园',
    component: (resolve) => require(['@/newHome/index'], resolve)
  },{
    path: '/ykt',
    name: '一卡通交易流水',
    component: (resolve) => require(['@/ykt/index'], resolve)
  },{
    path: '/rllr',
    name: '人脸录入',
    component: (resolve) => require(['@/rllr/index'], resolve)
  },{
    path: '/rllr/enterHistory',
    name: '人校记录',
    component: (resolve) => require(['@/rllr/enterHistory'], resolve)
  },{
    path: '/score',
    name: '成绩查询',
    component: (resolve) => require(['@/score/index'], resolve)
  },{
    path: '/wjdc',
    name: '问卷调查',
    component: (resolve) => require(['@/questionnaire/index'], resolve)
  },{
    path: '/wjdc/preview/:ques_guid',
    name: '问卷详情',
    component: (resolve) => require(['@/questionnaire/preview'], resolve)
  },{
    path: '/meeting/mylist',
    name: '我的会议',
    component: (resolve) => require(['@/meeting/meetingList'], resolve)
  },{
    path: '/meeting/details/:meetingid',
    name: '会议详情',
    component: (resolve) => require(['@/meeting/details'], resolve)
  },{
    path: '/meeting/qrcode/:meetingid',
    name: '会议签到二维码',
    component: (resolve) => require(['@/meeting/qrcode'], resolve)
  },{
    path: '/meeting/sgin/:meetingid/:qrcode/:time',
    name: '会议签到',
    component: (resolve) => require(['@/meeting/sgin'], resolve)
  },{
    path: '/meeting/sginList/:meetingid',
    name: '会议签到详情',
    component: (resolve) => require(['@/meeting/sginList'], resolve)
  },{
    path: '/sbsm',
    name: '设备扫码',
    component: (resolve) => require(['@/shebeisaoma/index'], resolve)
  },{
    path: '/sbsm/list',
    name: '我的扫码记录',
    component: (resolve) => require(['@/shebeisaoma/list'], resolve)
  },{
    path: '/sbsm/success',
    name: '设备扫码成功',
    component: (resolve) => require(['@/shebeisaoma/success'], resolve)
  },{
    path: '/sbsm/fail',
    name: '设备扫码失败',
    component: (resolve) => require(['@/shebeisaoma/fail'], resolve)
  },{
    path: '/dfjn',
    name: '党费缴纳',
    component: (resolve) => require(['@/dfjn/index'], resolve)
  },{
    path: '/dfjn/pay/:guid',
    name: '党费缴纳详情',
    component: (resolve) => require(['@/dfjn/pay'], resolve)
  },{
    path: '/dfjn/chart/:year',
    name: '党费缴纳情况',
    component: (resolve) => require(['@/dfjn/chart'], resolve)
  },{
    path: '/tfjn',
    name: '团费缴纳',
    component: (resolve) => require(['@/tfjn/index'], resolve)
  },{
    path: '/tfjn/pay/:year/:month',
    name: '团费缴纳详情',
    component: (resolve) => require(['@/tfjn/pay'], resolve)
  },{
    path: '/tfjn/chart/:year',
    name: '团费缴纳情况',
    component: (resolve) => require(['@/tfjn/chart'], resolve)
  },{
    path: '/oAuth',
    name: '身份认证',
    meta:{
      oAuth:'false'
    },
    component: (resolve) => require(['@/oAuth/index'], resolve)
  },{
    path: '/welcome',
    name: '校园迎新',
    meta:{
      oAuth:'false'
    },
    component: (resolve) => require(['@/welcome/index'], resolve)
  },{
    path: '/fail',
    name: '认证失败',
    meta:{
      oAuth:'false'
    },
    component: (resolve) => require(['@/oAuth/fail'], resolve)
  },{
    path: '/pass',
    name: '认证成功',
    meta:{
      oAuth:'false'
    },
    component: (resolve) => require(['@/oAuth/pass'], resolve)
  },{
    path: '/explain',
    name: '关注说明',
    meta:{
      oAuth:'false'
    },
    component: (resolve) => require(['@/oAuth/explain'], resolve)
  },{
    path: '/mpnews/:mpnewsid',
    name: '图文消息',
    component: (resolve) => require(['@/mpnews/index'], resolve)
  },{
    path: '/404',
    name: '404',
    component: (resolve) => require(['@/error/404.vue'], resolve)
  }, {
    path: '*',
    redirect: '/404'
  },{
    path: '/foodjump',
    name: '订餐跳转页面',
    component: (resolve) => require(['@/foodJump/index'], resolve)
  },{
    path: '/foodjump1',
    name: '订餐跳转页面1',
    component: (resolve) => require(['@/foodJump/index1'], resolve)
  }
  ,{
    path: '/foodjump2',
    name: '订餐跳转页面2',
    component: (resolve) => require(['@/foodJump/index2'], resolve)
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/router.js